import * as React from 'react';
import cx from 'classnames';
import Tiles from './components/Tiles/Tiles';
import { LiveMessaging } from './components/LiveMessaging/LiveMessaging';
import './Summary.scss';
import { CLASSNAME_PREFIX } from './componentConfig';
import { H3 } from '@sitebase/ui-kit';
export var Summary = function (props) {
    var _a;
    var data = props.data, isChatEnabled = props.isChatEnabled, clickHandler = props.clickHandler, translate = props.t;
    return (React.createElement("div", { className: cx("".concat(CLASSNAME_PREFIX, "-component"), (_a = {}, _a["".concat(CLASSNAME_PREFIX, "-component--witch-chat")] = isChatEnabled, _a)) },
        React.createElement("div", null,
            React.createElement(H3, null, translate('APP_TITLE')),
            React.createElement("p", { className: "".concat(CLASSNAME_PREFIX, "-component__disclaimer") },
                React.createElement("span", null,
                    translate('APP_DESCRIPTION_LINE_1'),
                    " ",
                    React.createElement("b", null, translate('APP_DESCRIPTION_LINE_2_BOLD')),
                    translate('APP_DESCRIPTION_LINE_2')))),
        React.createElement(Tiles, { data: data, clickHandler: clickHandler, t: translate }),
        isChatEnabled ? React.createElement(LiveMessaging, { t: translate }) : null));
};
//# sourceMappingURL=Summary.js.map